/**
 * Products API Service
 *
 * Provides helper methods to fetch consent templates / products required by the
 * create consent workflow.
 */

import { httpClient } from './http-client.service';

export interface ProductRecord {
  product_code: string;
  product_name: string;
  product_division?: string | null;
  status?: string | null;
  [key: string]: unknown;
}

export interface ProductsListResponse {
  data: {
    rows: ProductRecord[];
  };
  status?: string;
  message?: string;
}

class ProductsAPIService {
  /**
   * Fetch products/consent templates.
   *
   * Backend expects an empty object {} to return all products.
   * Note: Angular passes empty string but httpClient serializes differently than axios,
   * so we normalize empty/falsy payloads to empty object for consistency.
   */
  async getProducts(payload: unknown = {}): Promise<ProductsListResponse> {
    // Normalize empty string or falsy values to empty object for JSON body
    const normalizedPayload = payload === '' || !payload ? {} : payload;
    const response = await httpClient.post<ProductsListResponse>('productslist', normalizedPayload);
    return response.data;
  }
}

export const productsAPI = new ProductsAPIService();
